import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Container, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { LOW_INVENTORY_RESET } from '../constants/reportConstants'
import { ThemeContext } from '../components/ThemeContext.js'

const InventoryReports = () => {
  // get all inventory
  // find low inventory items
  // display list sorted by manufacturer

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { theme } = useContext(ThemeContext)

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const canManageAll = Boolean(ownerInfo || (userInfo && userInfo.isAdmin))

  useEffect(() => {
    if (!userInfo && !ownerInfo) {
      dispatch({ type: LOW_INVENTORY_RESET })
      navigate('/login')
    } else if (!canManageAll) {
      navigate('/pos')
    }
  }, [dispatch, navigate, userInfo, ownerInfo, canManageAll])

  return (
    <Container className='my-3' style={{ color: theme.text }}>
      <h3 style={{ color: theme.subtext }}>Inventory Reports</h3>
      <hr />
      <ul>
        <li>
          <Link
            to='/reports/lowinventory'
            style={{ color: theme.sidebarAccent }}
          >
            <h4>Low Inventory Report</h4>{' '}
          </Link>
        </li>
        <li>
          <h4>Number of receipts issued</h4>
        </li>
      </ul>
      <Button
        size='sm'
        variant='outline-primary'
        className='my-3'
        onClick={() => navigate('/inventory')}
      >
        To Inventory
      </Button>
    </Container>
  )
}

export default InventoryReports
